import { combineReducers } from 'redux';

import reducerExample from './reducerExample';

export default combineReducers({ reducerExample });
